import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = { class: "header-left" }
const _hoisted_3 = { class: "header-title-section" }
const _hoisted_4 = { class: "employee-navigator" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "emp-selector-wrapper" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "emp-counter" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "header-controls" }
const _hoisted_11 = { class: "year-month-selector" }
const _hoisted_12 = { class: "current-period" }
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "view-tabs" }
const _hoisted_18 = { class: "count-badge" }
const _hoisted_19 = { class: "modal-content" }
const _hoisted_20 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_21 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_22 = {
  key: 0,
  class: "calendar-grid-container"
}
const _hoisted_23 = { class: "caregiver-info-bar" }
const _hoisted_24 = { class: "caregiver-badge" }
const _hoisted_25 = { class: "avatar-text" }
const _hoisted_26 = { class: "badge-info" }
const _hoisted_27 = { class: "badge-name" }
const _hoisted_28 = { class: "badge-job" }
const _hoisted_29 = { class: "quick-stats" }
const _hoisted_30 = { class: "stat" }
const _hoisted_31 = { class: "stat-value" }
const _hoisted_32 = { class: "stat" }
const _hoisted_33 = { class: "stat-value" }
const _hoisted_34 = { class: "stat" }
const _hoisted_35 = { class: "stat-value" }
const _hoisted_36 = { class: "calendar-wrapper" }
const _hoisted_37 = { class: "calendar-header" }
const _hoisted_38 = { class: "calendar-body" }
const _hoisted_39 = { class: "day-header" }
const _hoisted_40 = { class: "day-number" }
const _hoisted_41 = {
  key: 0,
  class: "today-chip"
}
const _hoisted_42 = {
  key: 0,
  class: "day-schedules"
}
const _hoisted_43 = ["onMouseenter"]
const _hoisted_44 = { class: "chip-text" }
const _hoisted_45 = {
  key: 0,
  class: "more-schedules"
}
const _hoisted_46 = { class: "summary-section" }
const _hoisted_47 = { class: "patient-list-card" }
const _hoisted_48 = { class: "patient-chips" }
const _hoisted_49 = { class: "chip-name" }
const _hoisted_50 = { class: "chip-count" }
const _hoisted_51 = { class: "chip-hours" }
const _hoisted_52 = {
  key: 1,
  class: "calendar-grid-container"
}
const _hoisted_53 = { class: "patient-info-bar" }
const _hoisted_54 = { class: "patient-selector-area" }
const _hoisted_55 = { class: "select-wrapper" }
const _hoisted_56 = ["value"]
const _hoisted_57 = {
  key: 0,
  class: "family-chip"
}
const _hoisted_58 = { class: "patient-stats-row" }
const _hoisted_59 = { class: "stat-box" }
const _hoisted_60 = { class: "stat-value" }
const _hoisted_61 = { class: "stat-box" }
const _hoisted_62 = { class: "stat-value" }
const _hoisted_63 = { class: "stat-box" }
const _hoisted_64 = { class: "stat-value" }
const _hoisted_65 = { class: "stat-box suga" }
const _hoisted_66 = { class: "stat-value" }
const _hoisted_67 = { class: "calendar-wrapper" }
const _hoisted_68 = { class: "calendar-header" }
const _hoisted_69 = { class: "calendar-body" }
const _hoisted_70 = { class: "day-header" }
const _hoisted_71 = { class: "day-number" }
const _hoisted_72 = {
  key: 0,
  class: "today-chip"
}
const _hoisted_73 = { class: "day-schedules" }
const _hoisted_74 = { class: "chip-info" }
const _hoisted_75 = { class: "chip-time" }
const _hoisted_76 = { class: "chip-service" }
const _hoisted_77 = {
  key: 0,
  class: "more-schedules"
}

import { ref, computed, watch, nextTick } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';

interface ScheduleData {
  les_idx?: number;
  les_date: string;
  les_start_time: string;
  les_end_time: string;
  les_patient_name: string;
  les_patient_code?: string;
  les_caregiver_name: string;
  les_caregiver_birth?: string;
  les_caregiver_code?: string;
  les_caregiver_gubun?: string;
  les_familly_rel?: string;
  les_familly_who?: string;
  les_service_gubun?: string;
  les_suga_code?: string;
  les_suga_name?: string;
  les_suga_money?: number;
}

interface CalendarDay {
  day: number;
  date: string;
  isCurrentMonth: boolean;
  isToday: boolean;
}

interface Props {
  modelValue: boolean;
  employee: any;
  employees?: any[]; // 전체 직원 목록 (선택적)
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ScheduleCalendarModal',
  props: {
    modelValue: { type: Boolean },
    employee: {},
    employees: {}
  },
  emits: ["update:modelValue", "change-employee"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

// 현재 선택된 직원 인덱스
const currentEmployeeIndex = ref(0);

// 직원 목록 (props.employees가 있으면 사용, 없으면 현재 직원만)
const employeeList = computed(() => {
  if (props.employees && props.employees.length > 0) {
    return props.employees;
  }
  return props.employee ? [props.employee] : [];
});

// 현재 선택된 직원
const currentEmployee = computed(() => {
  return employeeList.value[currentEmployeeIndex.value] || props.employee;
});

// 이전/다음 이동 가능 여부
const canNavigatePrev = computed(() => currentEmployeeIndex.value > 0);
const canNavigateNext = computed(() => currentEmployeeIndex.value < employeeList.value.length - 1);

// 직원 이동
const navigateEmployee = (delta: number) => {
  const newIndex = currentEmployeeIndex.value + delta;
  if (newIndex >= 0 && newIndex < employeeList.value.length) {
    currentEmployeeIndex.value = newIndex;
    emit('change-employee', currentEmployee.value);
    fetchScheduleData();
  }
};

// 직원 선택 변경
const onEmployeeChange = () => {
  emit('change-employee', currentEmployee.value);
  fetchScheduleData();
};

const store = useStore();
const user = computed(() => store.state.user);

// 상태
const isLoading = ref(false);
const isPdfLoading = ref(false);
const isBatchPdfLoading = ref(false);
const scheduleData = ref<ScheduleData[]>([]);
const activeView = ref<'patient' | 'caregiver'>('caregiver');
const hoveredPatient = ref<string | null>(null); // 호버된 수급자 이름

// 연월 선택
const today = new Date();
const selectedYear = ref(today.getFullYear());
const selectedMonth = ref(today.getMonth() + 1);
const selectedPatient = ref('');

// 다이얼로그 표시 상태
const dialogVisible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
});

// 연도 옵션 (현재 연도 기준 ±2년)
const yearOptions = computed(() => {
  const currentYear = new Date().getFullYear();
  return [currentYear - 2, currentYear - 1, currentYear, currentYear + 1];
});

// 요일 배열
const weekDays = ['일', '월', '화', '수', '목', '금', '토'];

// 이미 백엔드에서 해당 사원의 일정만 필터링해서 가져옴
const filteredScheduleData = computed(() => {
  return scheduleData.value;
});

// 해당 사원이 담당하는 수급자 목록
const uniquePatients = computed(() => {
  const patients = new Set(filteredScheduleData.value.map(s => s.les_patient_name));
  return Array.from(patients).filter(Boolean).sort();
});

// 달력 일자 생성
const calendarDays = computed<CalendarDay[]>(() => {
  const year = selectedYear.value;
  const month = selectedMonth.value;
  
  const firstDay = new Date(year, month - 1, 1);
  const startDay = new Date(firstDay);
  startDay.setDate(startDay.getDate() - firstDay.getDay());
  
  const days: CalendarDay[] = [];
  const current = new Date(startDay);
  const todayStr = formatDateStr(today);
  
  for (let i = 0; i < 42; i++) {
    const isCurrentMonth = current.getMonth() === month - 1;
    const dateStr = formatDateStr(current);
    
    days.push({
      day: current.getDate(),
      date: dateStr,
      isCurrentMonth,
      isToday: dateStr === todayStr
    });
    
    current.setDate(current.getDate() + 1);
  }
  
  return days;
});

// 색상 팔레트 - 대비되는 순서로 배치
const patientColors: Record<string, string> = {};
const colorPalette = [
  '#ef4444', // 빨강
  '#3b82f6', // 파랑 (빨강과 대비)
  '#22c55e', // 초록 (파랑과 대비)
  '#a855f7', // 보라 (초록과 대비)
  '#f97316', // 주황 (보라와 대비)
  '#14b8a6', // 청록 (주황과 대비)
  '#ec4899', // 분홍 (청록과 대비)
  '#4f46e5', // 남색 (분홍과 대비)
  '#eab308', // 노랑 (남색과 대비)
  '#64748b', // 회색 (노랑과 대비)
];

const getPatientColor = (name: string): string => {
  if (!patientColors[name]) {
    const idx = Object.keys(patientColors).length % colorPalette.length;
    patientColors[name] = colorPalette[idx];
  }
  return patientColors[name];
};

// 날짜 포맷
const formatDateStr = (date: Date): string => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

// 시간 포맷
const formatTime = (time?: string): string => {
  if (!time) return '';
  const str = time.toString().replace(/[^0-9]/g, '');
  if (str.length >= 4) {
    return `${str.slice(0, 2)}:${str.slice(2, 4)}`;
  }
  return time;
};

// 일정 날짜 포맷 (YYYYMMDD -> YYYY-MM-DD)
const formatScheduleDate = (date: string): string => {
  if (!date) return '';
  const str = date.toString().replace(/[^0-9]/g, '');
  if (str.length === 8) {
    return `${str.slice(0, 4)}-${str.slice(4, 6)}-${str.slice(6, 8)}`;
  }
  return date;
};

// 요양보호사(선택한 사원)의 일정 조회
const getCaregiverSchedules = (dateStr: string): ScheduleData[] => {
  return filteredScheduleData.value.filter(s => {
    const scheduleDate = s.les_date?.includes('-') ? s.les_date : formatScheduleDate(s.les_date);
    return scheduleDate === dateStr;
  });
};

// 수급자별 일정 조회 (해당 사원이 담당하는 것만)
const getPatientSchedulesForCaregiver = (dateStr: string): ScheduleData[] => {
  if (!selectedPatient.value) return [];
  return filteredScheduleData.value.filter(s => {
    const scheduleDate = s.les_date?.includes('-') ? s.les_date : formatScheduleDate(s.les_date);
    return scheduleDate === dateStr && s.les_patient_name === selectedPatient.value;
  });
};

// 시간 차이 계산 (분 단위)
const calculateMinutes = (startTime: string, endTime: string): number => {
  const start = formatTime(startTime).split(':');
  const end = formatTime(endTime).split(':');
  if (start.length < 2 || end.length < 2) return 0;
  
  const startMinutes = parseInt(start[0]) * 60 + parseInt(start[1]);
  const endMinutes = parseInt(end[0]) * 60 + parseInt(end[1]);
  return Math.max(0, endMinutes - startMinutes);
};

// 분을 시간 문자열로 변환
const formatHours = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (mins > 0) return `${hours}h ${mins}m`;
  return `${hours}h`;
};

// 요양보호사(선택한 사원) 월간 통계
const getCaregiverMonthlyStats = computed(() => {
  const uniqueDays = new Set(filteredScheduleData.value.map(s => s.les_date));
  const uniquePatientsSet = new Set(filteredScheduleData.value.map(s => s.les_patient_name));
  
  let totalMinutes = 0;
  filteredScheduleData.value.forEach(s => {
    totalMinutes += calculateMinutes(s.les_start_time, s.les_end_time);
  });
  
  return {
    totalDays: uniqueDays.size,
    totalHours: formatHours(totalMinutes),
    patientCount: uniquePatientsSet.size
  };
});

// 수급자 월간 통계
const getPatientMonthlyStats = computed(() => {
  if (!selectedPatient.value) return { totalDays: 0, totalHours: '0h', visitCount: 0 };
  
  const patientSchedules = filteredScheduleData.value.filter(s => s.les_patient_name === selectedPatient.value);
  const uniqueDays = new Set(patientSchedules.map(s => s.les_date));
  
  let totalMinutes = 0;
  patientSchedules.forEach(s => {
    totalMinutes += calculateMinutes(s.les_start_time, s.les_end_time);
  });
  
  return {
    totalDays: uniqueDays.size,
    totalHours: formatHours(totalMinutes),
    visitCount: patientSchedules.length
  };
});

// 선택된 수급자의 수가총액
const getPatientTotalSuga = computed(() => {
  if (!selectedPatient.value) return 0;
  
  const patientSchedules = filteredScheduleData.value.filter(s => s.les_patient_name === selectedPatient.value);
  return patientSchedules.reduce((sum, s) => sum + (s.les_suga_money || 0), 0);
});

// 선택된 수급자의 가족요양 정보
const getPatientFamilyInfo = computed(() => {
  if (!selectedPatient.value) return { isFamily: false, who: '' };
  
  const patientSchedule = filteredScheduleData.value.find(s => s.les_patient_name === selectedPatient.value);
  if (patientSchedule && patientSchedule.les_familly_rel === 'Y') {
    return { isFamily: true, who: patientSchedule.les_familly_who || '' };
  }
  return { isFamily: false, who: '' };
});

// 금액 포맷
const formatMoney = (amount: number): string => {
  return amount.toLocaleString('ko-KR');
};

// 담당 수급자 목록 (횟수, 시간 포함)
const getCaregiverPatients = computed(() => {
  const ptData: Record<string, { count: number; minutes: number }> = {};
  
  filteredScheduleData.value.forEach(s => {
    if (!ptData[s.les_patient_name]) {
      ptData[s.les_patient_name] = { count: 0, minutes: 0 };
    }
    ptData[s.les_patient_name].count++;
    ptData[s.les_patient_name].minutes += calculateMinutes(s.les_start_time, s.les_end_time);
  });
  
  return Object.entries(ptData)
    .map(([name, data]) => ({ 
      name, 
      count: data.count,
      hours: formatHours(data.minutes)
    }))
    .sort((a, b) => b.count - a.count);
});

// 월 변경
const changeMonth = (delta: number) => {
  let newMonth = selectedMonth.value + delta;
  let newYear = selectedYear.value;
  
  if (newMonth > 12) {
    newMonth = 1;
    newYear++;
  } else if (newMonth < 1) {
    newMonth = 12;
    newYear--;
  }
  
  selectedMonth.value = newMonth;
  selectedYear.value = newYear;
  fetchScheduleData();
};

// 일정 데이터 조회
const fetchScheduleData = async () => {
  const emp = currentEmployee.value;
  if (!user.value?.m_sisul_code || !emp?.emp_name) {
    return;
  }
  
  try {
    isLoading.value = true;
    
    const url = `/api/files/data/${selectedYear.value}/${selectedMonth.value}/${encodeURIComponent('일정계획')}/${user.value.m_sisul_code}`;
    
    // 특정 요양보호사의 일정만 조회 (이름 + 생년월일로 정확히 매칭)
    const response = await axios.get(url, { 
      params: { 
        caregiverName: emp.emp_name,
        caregiverBirth: emp.emp_birth
      },
      withCredentials: true 
    });
    
    
    if (response.data.success && response.data.data?.rows) {
      scheduleData.value = response.data.data.rows;
      
      // 첫 번째 수급자 자동 선택
      if (uniquePatients.value.length > 0 && !uniquePatients.value.includes(selectedPatient.value)) {
        selectedPatient.value = uniquePatients.value[0];
      }
    } else {
      scheduleData.value = [];
    }
  } catch (error) {
    console.error('일정 데이터 조회 오류:', error);
    scheduleData.value = [];
  } finally {
    isLoading.value = false;
  }
};

// 일정표 PDF 출력
const printSchedulePdf = async () => {
  const emp = currentEmployee.value;
  if (!user.value?.m_sisul_code || !emp?.emp_code) {
    alert('직원 정보가 없습니다.');
    return;
  }
  
  try {
    isPdfLoading.value = true;
    
    const yearMonth = `${selectedYear.value}${String(selectedMonth.value).padStart(2, '0')}`;
    
    const response = await axios.get(
      `/api/beneficiary/caregiver-schedule-pdf/${user.value.m_sisul_code}/${emp.emp_code}/${yearMonth}`,
      { responseType: 'blob' }
    );
    
    // PDF 다운로드
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `일정표_${emp.emp_name}_${yearMonth}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('일정표 PDF 출력 오류:', error);
    alert('일정표 PDF 출력에 실패했습니다.');
  } finally {
    isPdfLoading.value = false;
  }
};

// 전체 요양보호사 일정표 PDF 일괄 출력
const printAllCaregiversPdf = async () => {
  if (!user.value?.m_sisul_code) {
    alert('시설 정보가 없습니다.');
    return;
  }
  
  const caregiverCount = employeeList.value.length;
  if (caregiverCount === 0) {
    alert('출력할 요양보호사가 없습니다.');
    return;
  }
  
  // 확인 메시지
  if (!confirm(`${selectedYear.value}년 ${selectedMonth.value}월 전체 요양보호사(${caregiverCount}명)의 일정표를 PDF로 출력하시겠습니까?\n\n데이터 양에 따라 시간이 소요될 수 있습니다.`)) {
    return;
  }
  
  try {
    isBatchPdfLoading.value = true;
    
    const yearMonth = `${selectedYear.value}${String(selectedMonth.value).padStart(2, '0')}`;
    
    const response = await axios.get(
      `/api/beneficiary/all-caregivers-schedule-pdf/${user.value.m_sisul_code}/${yearMonth}`,
      { responseType: 'blob' }
    );
    
    // PDF 다운로드
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `전체요양보호사_일정표_${yearMonth}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('전체 요양보호사 일정표 PDF 출력 오류:', error);
    alert('전체 요양보호사 일정표 PDF 출력에 실패했습니다.');
  } finally {
    isBatchPdfLoading.value = false;
  }
};

// 닫기
const close = () => {
  dialogVisible.value = false;
};

// 다이얼로그 열릴 때 데이터 조회
watch(dialogVisible, async (visible) => {
  if (visible) {
    // 현재 연월로 초기화
    selectedYear.value = today.getFullYear();
    selectedMonth.value = today.getMonth() + 1;
    selectedPatient.value = '';
    activeView.value = 'caregiver'; // 기본은 해당 사원의 근무일정
    
    // 현재 직원 인덱스 초기화 (props.employee가 목록에 있으면 해당 인덱스로)
    if (props.employees && props.employees.length > 0 && props.employee) {
      const idx = props.employees.findIndex(e => 
        e.emp_code === props.employee.emp_code || 
        (e.emp_name === props.employee.emp_name && e.emp_birth === props.employee.emp_birth)
      );
      currentEmployeeIndex.value = idx >= 0 ? idx : 0;
    } else {
      currentEmployeeIndex.value = 0;
    }
    
    // props.employee가 업데이트될 때까지 대기
    await nextTick();
    
    if (currentEmployee.value?.emp_name) {
      await fetchScheduleData();
    }
  }
});

// 연도 또는 월이 변경될 때 데이터 재조회
watch([selectedYear, selectedMonth], async ([newYear, newMonth], [oldYear, oldMonth]) => {
  // 모달이 열려있고 값이 실제로 변경된 경우에만 조회
  if (dialogVisible.value && (newYear !== oldYear || newMonth !== oldMonth)) {
    await fetchScheduleData();
  }
});

// 수급자 목록 변경 시 선택 값 업데이트
watch(uniquePatients, (patients) => {
  if (patients.length > 0 && !patients.includes(selectedPatient.value)) {
    selectedPatient.value = patients[0];
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((dialogVisible).value = $event)),
    "max-width": "1200px",
    scrollable: "",
    height: "90vh"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "schedule-calendar-modal" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_icon, {
                size: "28",
                color: "white"
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode("mdi-calendar-clock", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("button", {
                    class: "emp-nav-btn prev",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (navigateEmployee(-1))),
                    disabled: !canNavigatePrev.value,
                    title: "이전 직원"
                  }, [
                    _createVNode(_component_v_icon, { size: "20" }, {
                      default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                        _createTextVNode("mdi-chevron-left", -1)
                      ]))]),
                      _: 1
                    })
                  ], 8, _hoisted_5),
                  _createElementVNode("div", _hoisted_6, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentEmployeeIndex).value = $event)),
                      class: "emp-select",
                      onChange: onEmployeeChange
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(employeeList.value, (emp, idx) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: emp.emp_code || idx,
                          value: idx
                        }, _toDisplayString(emp.emp_name) + " (" + _toDisplayString(emp.emp_job) + ") ", 9, _hoisted_7))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, currentEmployeeIndex.value]
                    ]),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(currentEmployeeIndex.value + 1) + " / " + _toDisplayString(employeeList.value.length), 1)
                  ]),
                  _createElementVNode("button", {
                    class: "emp-nav-btn next",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (navigateEmployee(1))),
                    disabled: !canNavigateNext.value,
                    title: "다음 직원"
                  }, [
                    _createVNode(_component_v_icon, { size: "20" }, {
                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                        _createTextVNode("mdi-chevron-right", -1)
                      ]))]),
                      _: 1
                    })
                  ], 8, _hoisted_9)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  class: "nav-btn",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (changeMonth(-1)))
                }, [
                  _createVNode(_component_v_icon, { size: "20" }, {
                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                      _createTextVNode("mdi-chevron-left", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedYear).value = $event)),
                    class: "year-select"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yearOptions.value, (y) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: y,
                        value: y
                      }, _toDisplayString(y) + "년", 9, _hoisted_13))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, selectedYear.value]
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedMonth).value = $event)),
                    class: "month-select"
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (m) => {
                      return _createElementVNode("option", {
                        key: m,
                        value: m
                      }, _toDisplayString(m) + "월", 9, _hoisted_14)
                    }), 64))
                  ], 512), [
                    [_vModelSelect, selectedMonth.value]
                  ])
                ]),
                _createElementVNode("button", {
                  class: "nav-btn",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (changeMonth(1)))
                }, [
                  _createVNode(_component_v_icon, { size: "20" }, {
                    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                      _createTextVNode("mdi-chevron-right", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("button", {
                class: "pdf-btn",
                onClick: printSchedulePdf,
                disabled: isPdfLoading.value || filteredScheduleData.value.length === 0,
                title: "현재 직원 일정표 PDF 출력"
              }, [
                _createVNode(_component_v_icon, {
                  size: "20",
                  color: "white"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(isPdfLoading.value ? 'mdi-loading mdi-spin' : 'mdi-file-pdf-box'), 1)
                  ]),
                  _: 1
                }),
                _cache[17] || (_cache[17] = _createElementVNode("span", null, "PDF", -1))
              ], 8, _hoisted_15),
              _createElementVNode("button", {
                class: "batch-pdf-btn",
                onClick: printAllCaregiversPdf,
                disabled: isBatchPdfLoading.value || employeeList.value.length === 0,
                title: "전체 요양보호사 일정표 PDF 출력"
              }, [
                _createVNode(_component_v_icon, {
                  size: "20",
                  color: "white"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(isBatchPdfLoading.value ? 'mdi-loading mdi-spin' : 'mdi-file-document-multiple'), 1)
                  ]),
                  _: 1
                }),
                _cache[18] || (_cache[18] = _createElementVNode("span", null, "전체", -1))
              ], 8, _hoisted_16),
              _createElementVNode("button", {
                class: "close-btn",
                onClick: close
              }, [
                _createVNode(_component_v_icon, {
                  size: "24",
                  color: "white"
                }, {
                  default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                    _createTextVNode("mdi-close", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("button", {
              class: _normalizeClass(["view-tab", { active: activeView.value === 'caregiver' }]),
              onClick: _cache[7] || (_cache[7] = ($event: any) => (activeView.value = 'caregiver'))
            }, [
              _createVNode(_component_v_icon, { size: "20" }, {
                default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                  _createTextVNode("mdi-account-hard-hat", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("span", null, _toDisplayString(currentEmployee.value?.emp_name) + " 근무일정", 1)
            ], 2),
            _createElementVNode("button", {
              class: _normalizeClass(["view-tab", { active: activeView.value === 'patient' }]),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (activeView.value = 'patient'))
            }, [
              _createVNode(_component_v_icon, { size: "20" }, {
                default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                  _createTextVNode("mdi-account-heart", -1)
                ]))]),
                _: 1
              }),
              _cache[22] || (_cache[22] = _createElementVNode("span", null, "담당 수급자", -1)),
              _createElementVNode("span", _hoisted_18, _toDisplayString(uniquePatients.value.length), 1)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_19, [
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createVNode(_component_v_progress_circular, {
                    indeterminate: "",
                    color: "#1e3a8a",
                    size: "48"
                  }),
                  _cache[23] || (_cache[23] = _createElementVNode("span", null, "일정을 불러오는 중...", -1))
                ]))
              : (filteredScheduleData.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createVNode(_component_v_icon, {
                      size: "64",
                      color: "#cbd5e1"
                    }, {
                      default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                        _createTextVNode("mdi-calendar-blank", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[25] || (_cache[25] = _createElementVNode("h3", null, "일정 데이터가 없습니다", -1)),
                    _createElementVNode("p", null, _toDisplayString(selectedYear.value) + "년 " + _toDisplayString(selectedMonth.value) + "월에 " + _toDisplayString(currentEmployee.value?.emp_name) + "님의 일정이 없습니다.", 1)
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (activeView.value === 'caregiver')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _createVNode(_component_v_avatar, {
                                size: "36",
                                color: "#1e3a8a"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_25, _toDisplayString(currentEmployee.value?.emp_name?.charAt(0)), 1)
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("span", _hoisted_27, _toDisplayString(currentEmployee.value?.emp_name), 1),
                                _createElementVNode("span", _hoisted_28, _toDisplayString(currentEmployee.value?.emp_job), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("span", _hoisted_31, _toDisplayString(getCaregiverMonthlyStats.value.totalDays), 1),
                                _cache[26] || (_cache[26] = _createElementVNode("span", { class: "stat-label" }, "근무일", -1))
                              ]),
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("span", _hoisted_33, _toDisplayString(getCaregiverMonthlyStats.value.totalHours), 1),
                                _cache[27] || (_cache[27] = _createElementVNode("span", { class: "stat-label" }, "총 시간", -1))
                              ]),
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("span", _hoisted_35, _toDisplayString(getCaregiverMonthlyStats.value.patientCount), 1),
                                _cache[28] || (_cache[28] = _createElementVNode("span", { class: "stat-label" }, "담당 수급자", -1))
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekDays, (day) => {
                                return _createElementVNode("div", {
                                  class: "weekday",
                                  key: day
                                }, _toDisplayString(day), 1)
                              }), 64))
                            ]),
                            _createElementVNode("div", _hoisted_38, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calendarDays.value, (day, idx) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: idx,
                                  class: _normalizeClass(["calendar-day", { 
                    'other-month': !day.isCurrentMonth,
                    'today': day.isToday,
                    'has-schedule': getCaregiverSchedules(day.date).length > 0
                  }])
                                }, [
                                  _createElementVNode("div", _hoisted_39, [
                                    _createElementVNode("div", _hoisted_40, _toDisplayString(day.day), 1),
                                    (day.isToday)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_41, "TODAY"))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (day.isCurrentMonth)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getCaregiverSchedules(day.date).slice(0, 4), (schedule, sIdx) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: sIdx,
                                            class: _normalizeClass(["schedule-chip-inline", { 'highlighted': hoveredPatient.value === schedule.les_patient_name }]),
                                            style: _normalizeStyle({ borderColor: getPatientColor(schedule.les_patient_name) }),
                                            onMouseenter: ($event: any) => (hoveredPatient.value = schedule.les_patient_name),
                                            onMouseleave: _cache[9] || (_cache[9] = ($event: any) => (hoveredPatient.value = null))
                                          }, [
                                            _createElementVNode("div", {
                                              class: "chip-dot",
                                              style: _normalizeStyle({ borderColor: getPatientColor(schedule.les_patient_name) })
                                            }, null, 4),
                                            _createElementVNode("span", _hoisted_44, _toDisplayString(schedule.les_patient_name) + " " + _toDisplayString(formatTime(schedule.les_start_time)) + "-" + _toDisplayString(formatTime(schedule.les_end_time)), 1)
                                          ], 46, _hoisted_43))
                                        }), 128)),
                                        (getCaregiverSchedules(day.date).length > 4)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, " +" + _toDisplayString(getCaregiverSchedules(day.date).length - 4), 1))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 2))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, [
                              _createElementVNode("h4", null, [
                                _createVNode(_component_v_icon, {
                                  size: "20",
                                  color: "#0ea5e9"
                                }, {
                                  default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                    _createTextVNode("mdi-account-heart", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[30] || (_cache[30] = _createTextVNode(" 담당 수급자 목록 ", -1))
                              ]),
                              _createElementVNode("div", _hoisted_48, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getCaregiverPatients.value, (pt) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: pt.name,
                                    class: "patient-chip",
                                    style: _normalizeStyle({ borderColor: getPatientColor(pt.name) })
                                  }, [
                                    _createElementVNode("div", {
                                      class: "chip-color",
                                      style: _normalizeStyle({ backgroundColor: getPatientColor(pt.name) })
                                    }, null, 4),
                                    _createElementVNode("span", _hoisted_49, _toDisplayString(pt.name), 1),
                                    _createElementVNode("span", _hoisted_50, _toDisplayString(pt.count) + "회", 1),
                                    _createElementVNode("span", _hoisted_51, _toDisplayString(pt.hours), 1)
                                  ], 4))
                                }), 128))
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (activeView.value === 'patient')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("div", _hoisted_54, [
                              _cache[32] || (_cache[32] = _createElementVNode("label", { class: "select-label" }, "수급자 선택", -1)),
                              _createElementVNode("div", _hoisted_55, [
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((selectedPatient).value = $event)),
                                  class: "person-select"
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uniquePatients.value, (patient) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: patient,
                                      value: patient
                                    }, _toDisplayString(patient), 9, _hoisted_56))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, selectedPatient.value]
                                ]),
                                _cache[31] || (_cache[31] = _createElementVNode("span", { class: "select-arrow" }, "▼", -1))
                              ]),
                              (getPatientFamilyInfo.value.isFamily)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_57, " 가족요양 · " + _toDisplayString(getPatientFamilyInfo.value.who), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_58, [
                              _createElementVNode("div", _hoisted_59, [
                                _createElementVNode("span", _hoisted_60, _toDisplayString(getPatientMonthlyStats.value.totalDays), 1),
                                _cache[33] || (_cache[33] = _createElementVNode("span", { class: "stat-label" }, "서비스일", -1))
                              ]),
                              _createElementVNode("div", _hoisted_61, [
                                _createElementVNode("span", _hoisted_62, _toDisplayString(getPatientMonthlyStats.value.totalHours), 1),
                                _cache[34] || (_cache[34] = _createElementVNode("span", { class: "stat-label" }, "총시간", -1))
                              ]),
                              _createElementVNode("div", _hoisted_63, [
                                _createElementVNode("span", _hoisted_64, _toDisplayString(getPatientMonthlyStats.value.visitCount), 1),
                                _cache[35] || (_cache[35] = _createElementVNode("span", { class: "stat-label" }, "방문", -1))
                              ]),
                              _createElementVNode("div", _hoisted_65, [
                                _createElementVNode("span", _hoisted_66, _toDisplayString(formatMoney(getPatientTotalSuga.value)), 1),
                                _cache[36] || (_cache[36] = _createElementVNode("span", { class: "stat-label" }, "수가총액(원)", -1))
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_67, [
                            _createElementVNode("div", _hoisted_68, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekDays, (day) => {
                                return _createElementVNode("div", {
                                  class: "weekday",
                                  key: day
                                }, _toDisplayString(day), 1)
                              }), 64))
                            ]),
                            _createElementVNode("div", _hoisted_69, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calendarDays.value, (day, idx) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: idx,
                                  class: _normalizeClass(["calendar-day", { 
                    'other-month': !day.isCurrentMonth,
                    'today': day.isToday,
                    'has-schedule': getPatientSchedulesForCaregiver(day.date).length > 0
                  }])
                                }, [
                                  _createElementVNode("div", _hoisted_70, [
                                    _createElementVNode("div", _hoisted_71, _toDisplayString(day.day), 1),
                                    (day.isToday)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_72, "TODAY"))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_73, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getPatientSchedulesForCaregiver(day.date).slice(0, 3), (schedule, sIdx) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: sIdx,
                                        class: "schedule-chip caregiver"
                                      }, [
                                        _cache[37] || (_cache[37] = _createElementVNode("div", { class: "chip-dot" }, null, -1)),
                                        _createElementVNode("div", _hoisted_74, [
                                          _createElementVNode("span", _hoisted_75, _toDisplayString(formatTime(schedule.les_start_time)) + "-" + _toDisplayString(formatTime(schedule.les_end_time)), 1),
                                          _createElementVNode("span", _hoisted_76, "수가: " + _toDisplayString(formatMoney(schedule.les_suga_money || 0)) + "원", 1)
                                        ])
                                      ]))
                                    }), 128)),
                                    (getPatientSchedulesForCaregiver(day.date).length > 3)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_77, " +" + _toDisplayString(getPatientSchedulesForCaregiver(day.date).length - 3) + "건 ", 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 2))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})